import FiltersFormBar from "./FiltersFormBar";
import {WlDropdown} from "../../webcomponents/dropdown/dropdown.component";

export class ForeclosureExcluded {
    private form: FiltersFormBar;
    private readonly excludeButton: HTMLButtonElement | null;
    private readonly filter: WlDropdown;

    constructor(filtersFormBar: FiltersFormBar) {
        this.form = filtersFormBar
        this.excludeButton = document.querySelector(".js_exclude-foreclosures")
        this.filter = document.querySelector<WlDropdown>('[name="foreclosures"]')!
    }

    init() {
        if (!this.excludeButton) {
            return;
        }

        this.excludeButton.addEventListener('click', () => {
            if (this.filter) {
                this.filter.changeValue('excluded', 'excluded');
                this.form.submit()
            }
        });
    }
}